/**
 * Helpers for creating Customers instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { Customer } from "le-coffre-resources/dist/Notary";
import type { ApiPayload, QueryPayload } from "../../../../types";
import type { IGetCustomersparams, IPutCustomersParams } from "../Customers";
import {
	createGetMethod,
	createPostMethod,
	createGetByUidMethod,
	createPutMethod,
	createSendReminderMethod,
	createResendInvitationMethod,
	createSendLoginCodeMethod,
} from "./customersMethodsHelpers";

export interface CustomersInstance {
	get(q: IGetCustomersparams): Promise<Customer[]>;
	post(body: ApiPayload): Promise<Customer>;
	getByUid(uid: string, q?: QueryPayload): Promise<Customer>;
	put(uid: string, body: IPutCustomersParams): Promise<Customer>;
	sendReminder(uid: string, documentsUid: string[]): Promise<void>;
	resendInvitation(uid: string): Promise<void>;
	sendLoginCode(uid: string): Promise<{ message: string; code: string }>;
}

/**
 * Create Customers instance with all methods
 */
export function createCustomersInstance(baseNotary: IBaseNotary): CustomersInstance {
	const baseUrl = baseNotary.namespaceUrl.concat("/customers");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		put: createPutMethod(baseNotary, baseUrl),
		sendReminder: createSendReminderMethod(baseNotary, baseUrl),
		resendInvitation: createResendInvitationMethod(baseNotary, baseUrl),
		sendLoginCode: createSendLoginCodeMethod(baseNotary, baseUrl),
	};
}
